<template>
  <CalendarInput
    v-bind="$attrs"
    :min-date="minDate"
    :max-date="maxDate"
    :loading="calendar.busy"
    :holidays="allHolidays"
    :disable-date="disableDates"
    v-on="$listeners"
    @changeStartDate="fetch"
  >
    <template #date="{ date, label, outRange }">
      <div v-if="!outRange" class="date">
        <div>{{ label }}</div>
        <ReceptionStatus
          :status="(calendar.byDate[date] || {}).status"
          :not-available-type="rsvNotAvailableType"
          :tel="tel"
        />
      </div>
    </template>
  </CalendarInput>
</template>

<script>
import { addDays } from 'date-fns'
import { debounce } from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { formatDate, today } from '@/utils/date'
import CalendarInput from '@/components/molecules/CalendarInput'
import ReceptionStatus from '@/components/molecules/ReceptionStatus'

/**
 * 予約日入力
 */
export default {
  name: 'ReserveDateInput',
  components: {
    CalendarInput,
    ReceptionStatus,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    ...mapState({
      calendar: state => state.reception.calendar,
      rsvNotAvailableType: state => state.reception.setting.rsvNotAvailableType,
      tel: state => state.reception.setting.store.tel,
    }),
    ...mapGetters({
      allHolidays: 'holidays/all',
      selectedCourse: 'reservation/edit/selectedCourse',
    }),
    minDate() {
      return today()
    },
    maxDate() {
      return formatDate(addDays(today(), 180))
    },
    disableDates() {
      return Object.keys(this.calendar.byDate).filter(date => this.calendar.byDate[date].status !== 1)
    },
  },
  methods: {
    fetch: debounce(function(date) {
      this.$store.dispatch('reception/calendar/get', {
        date: date,
        courseId: this.selectedCourse.id >= 0 ? this.selectedCourse.id : null,
      })
    }, 200),
  },
}
</script>

<style lang="postcss" scoped>
.date {
  display: flex;
  display: grid;
  flex-direction: column;
  font-size: 12px;
  grid-gap: 8px;
  justify-items: center;
  line-height: 1.2;
  padding: 8px;
}
</style>
